import { render, staticRenderFns } from "./QuestionsTrivia2.vue?vue&type=template&id=a71f4134&scoped=true"
import script from "./QuestionsTrivia2.vue?vue&type=script&lang=js"
export * from "./QuestionsTrivia2.vue?vue&type=script&lang=js"
import style0 from "./QuestionsTrivia2.vue?vue&type=style&index=0&id=a71f4134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71f4134",
  null
  
)

export default component.exports